<template>
  <!-- 评价卡片 盒子 -->
  <div class='evaluate-container'>
    <div class="evaluate-box">
      <p class="title-desc">您对查询结果满意吗？</p>
      <div :class="['evaluate-select', {'justify-center':+isSatisfied!==-1}]">
        <div class='item-side' v-if="+isSatisfied!==0" @click="selectEvaluate(1)">
          <img src='@/assets/images/evaluate_good.svg'/>
          <span :class="['evaluate-btn', {'evaluate-btn-active':isSatisfied===1}]">满意哦~</span>
        </div>
        <div class='item-side' v-if="+isSatisfied!==1" @click="selectEvaluate(0)">
          <img src='@/assets/images/evaluate_bad.svg'/>
          <span :class="['evaluate-btn', {'evaluate-btn-active':isSatisfied===0}]">不满意</span>
        </div>
      </div>
      <div v-if="+isSatisfied===0" class='noSatisfied-container'>
        <p class='bad-title'>不满意原因</p>
        <div class='bad-select'>
          <span v-for="item in noSatisfyList"
            :key="item"
            :class="['bad-select-item', {'select-item-active': noSatisfied.lab.includes(item)}]"
            @click="handleBadSelect(item)">
            {{ item }}
          </span>
        </div>
        <div class="info-field">
          <div class="field-body">
            <textarea v-model="noSatisfied.msg"
              class="field-control"
              :maxlength="maxLength"
              placeholder="说说您建议，我们将努力改进哦~" />
          </div>
          <div v-if="maxLength" class="field-word-limit">
            <span class="field-word-num">{{ noSatisfied.msg.length }}</span>/{{ maxLength }}
          </div>
        </div>
        <div class='evaluate-submit' @click='onSubmitEvaluation(0)'>提交</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    isSatisfied: {
      type: [String, Number],
      default: ''
    },
    maxLength: {
      type: [String, Number],
      default: '200'
    },
    noSatisfied: {
      type: Object,
      default: () => {
        return {
          lab: [], // 不满意标签
          msg: '' // 不满意说明
        }
      }
    },
    noSatisfyList: {
      type: Array,
      default: () => {
        return ['费用太贵', '结果不准确', '操作不方便']
      }
    }
  },
  data () {
    return {
    }
  },
  filters: {},
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    selectEvaluate (value) {
      this.$emit('selectEvaluate', value)
    },
    handleBadSelect (label) {
      this.$emit('handleBadSelect', label)
    },
    onSubmitEvaluation (value) {
      this.$emit('onSubmitEvaluation', value)
    }
  } /* methods末 */
}
</script>

<style lang="scss" scoped>
.evaluate-container {
  position: relative;
  padding-top: torem(20px);
  padding-bottom: torem(14px);
  margin-bottom: torem(10px);
  background-color: #fff;
  border-radius: torem(8px);

  .title-desc {
    margin-bottom: torem(10px);
    color: #333;
    font-size: torem(14px);
    font-weight: 600;
    line-height: torem(20px);
    text-align: center;
  }

  .evaluate-select {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    // padding-bottom: torem(20px);
    // margin: 0 torem(12px);
    text-align: center;

    &.justify-center {
      justify-content: center;
    }

    .item-side {
      display: flex;
      align-items: center;

      &:not(:last-child) {
        margin-right: torem(30px);
      }
    }

    .evaluate-btn {
      display: flex;
      width: torem(93px);
      height: torem(30px);
      align-items: center;
      justify-content: center;
      margin-left: torem(10px);
      background: #f3f4f5;
      border-radius: 200px;
      font-size: torem(14px);

      &.evaluate-btn-active {
        border: torem(1px) solid #ff9000;
        background-color: #fff;
        color: #ff9000;
      }
    }
  }

  .noSatisfied-container {
    position: relative;
    padding: 0 torem(14px);
    margin-top: torem(10px);
  }

  .bad-title {
    color: #333;
    font-size: torem(14px);
    line-height: torem(50px);

    @include setOnePx(top, #eeeeee);
  }

  .bad-select {
    display: flex;
    justify-content: center;

    .bad-select-item {
      padding: 0 torem(16px);
      border-radius: torem(24px);
      color: #999;
      font-size: torem(14px);
      line-height: torem(30px);
      text-align: center;
      // border: torem(1px) solid #eee;
      @include setAllPx(#eee, 30px);

      &:not(:last-child) {
        margin-right: torem(10px);
      }
    }

    .select-item-active {
      // border: torem(1px) solid #ff9000;
      @include setAllPx(#ff9000, 30px);

      color: #ff9000;
    }
  }

  .info-field {
    padding: torem(10px);
    margin: torem(10px) 0;
    background-color: #f9f9f9;
    border-radius: torem(4px);
    color: #333;
    font-size: torem(14px);

    .field-body {
      display: flex;
      align-items: center;

      textarea {
        // background-color: $color-bg-grey;
        border: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: transparent;
        border-radius: 0;
        caret-color: #ff9000;
        color: inherit;
        font: inherit;
        outline: 0;
        resize: none;

        &::-webkit-input-placeholder {
          color: #999;
        }

        &::-webkit-search-cancel-button {
          display: none;
        }
      }
    }

    .field-control {
      width: 100%;
      height: torem(60px);
    }

    .field-word-limit {
      color: #999;
      font-size: torem(12px);
      line-height: torem(20px);
      text-align: right;
    }
  }

  .evaluate-submit {
    width: torem(120px);
    margin: 0 auto;
    background-color: #ff9000;
    border-radius: torem(22px);
    color: #fff;
    font-size: torem(16px);
    line-height: torem(44px);
    text-align: center;
  }
}
</style>
